import { verifyConnection, getSupabaseConfig } from './lib/supabase';

// Log environment check
console.log('Environment Check:');

// Get Supabase configuration
const config = getSupabaseConfig();

// Validate Supabase URL format
const isValidUrl = config.url && /^https:\/\/[a-zA-Z0-9-]+\.supabase\.co$/.test(config.url);

console.log('Supabase Configuration:', {
  url: isValidUrl ? 'Valid format' : 'Invalid format',
  hasKey: config.hasKey
});

// Test connection with improved error handling using IIFE
(async () => {
  try {
    await verifyConnection();
    console.log('✅ Supabase connection test passed');
  } catch (error: any) {
    // Log the error but don't halt execution
    if (error.message === 'Sessão não encontrada') {
      console.warn('⚠️ No active session found - this is expected if you are not logged in');
    } else if (error.message.includes('Sessão expirada')) {
      console.warn('⚠️ Session expired - please log in again');
    } else {
      console.error('❌ Supabase connection test failed:', error.message);
    }
  }
})();